import { render, staticRenderFns } from "./InformacoesUsuario.vue?vue&type=template&id=365cdc61&scoped=true"
import script from "./InformacoesUsuario.vue?vue&type=script&lang=js"
export * from "./InformacoesUsuario.vue?vue&type=script&lang=js"
import style0 from "./InformacoesUsuario.vue?vue&type=style&index=0&id=365cdc61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365cdc61",
  null
  
)

export default component.exports